import 'react';
import styled, { css } from 'styled-components';
import { Body, body } from '@lendi-ui/typography';
import { color, fg, bg } from '@lendi-ui/color';
import { p, ml, mt, my, margin } from '@lendi-ui/spacing';
import { select } from '@lendi-ui/theme';
import { normalise } from '@lendi-ui/utils';
import Info from '@lendi-ui/icon/Info';
import CheckCircleOutline from '@lendi-ui/icon/CheckCircleOutline';
import ErrorOutline from '@lendi-ui/icon/ErrorOutline';
import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var Wrapper = styled.div.withConfig({
  displayName: "indexstyle__Wrapper",
  componentId: "lui__sc-9k4a9t-0"
})(["", ";display:flex;align-items:flex-start;border-radius:", ";", " ", " ", ""], normalise, select('borderRadius'), p('sm'), _ref => {
  var {
    withHeading
  } = _ref;

  if (withHeading) {
    return css(["flex-direction:column;"]);
  }

  return css(["flex-direction:row;"]);
}, _ref2 => {
  var {
    variant
  } = _ref2;

  switch (variant) {
    case 'error':
      return css(["border:1px solid ", ";", " ", ";"], color('error.500'), fg('error.500'), bg('error.25'));

    case 'info':
      return css(["border:1px solid ", ";", " ", ";"], color('info.500'), fg('info.500'), bg('info.25'));

    case 'success':
      return css(["border:1px solid ", ";", " ", ";"], color('success.500'), fg('success.500'), bg('success.25'));

    case 'warn':
      return css(["border:1px solid ", ";", " ", ";"], color('warn.500'), fg('warn.500'), bg('warn.25'));

    default:
      return undefined;
  }
});
var HeaderWrapper = styled.div.withConfig({
  displayName: "indexstyle__HeaderWrapper",
  componentId: "lui__sc-9k4a9t-1"
})(["display:flex;flex-direction:row;align-items:center;"]);
var IconWrapper = styled.span.withConfig({
  displayName: "indexstyle__IconWrapper",
  componentId: "lui__sc-9k4a9t-2"
})(["line-height:0;"]);
var HeadingWrapper = styled(Body).withConfig({
  displayName: "indexstyle__HeadingWrapper",
  componentId: "lui__sc-9k4a9t-3"
})(["", ";"], ml('xs'));
var TextContentWrapper = styled(Body).withConfig({
  displayName: "indexstyle__TextContentWrapper",
  componentId: "lui__sc-9k4a9t-4"
})(["", ";"], _ref3 => {
  var {
    withHeading
  } = _ref3;
  return withHeading ? mt('xxxs') : ml('xs');
});
var ContentWrapper = styled.div.withConfig({
  displayName: "indexstyle__ContentWrapper",
  componentId: "lui__sc-9k4a9t-5"
})(["", ";", " ", " ", ";"], _ref4 => {
  var {
    withHeading
  } = _ref4;
  return withHeading ? mt('xxxs') : ml('xs');
}, my('nil'), body, margin);

var _excluded = ["variant", "heading", "children"];
var Alert = _ref => {
  var {
    variant,
    heading,
    children
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var alertIcon;
  var withHeading = !!heading;

  switch (variant) {
    case 'error':
      alertIcon = /*#__PURE__*/jsx(ErrorOutline, {
        color: "error.500"
      });
      break;

    case 'info':
      alertIcon = /*#__PURE__*/jsx(Info, {
        color: "info.500"
      });
      break;

    case 'success':
      alertIcon = /*#__PURE__*/jsx(CheckCircleOutline, {
        color: "success.500"
      });
      break;

    case 'warn':
      alertIcon = /*#__PURE__*/jsx(ErrorOutline, {
        color: "warn.500"
      });
      break;
  }

  var alertBody = typeof children === 'string' ? /*#__PURE__*/jsx(TextContentWrapper, {
    withHeading: withHeading,
    size: "xs",
    children: children
  }) : /*#__PURE__*/jsx(ContentWrapper, {
    withHeading: withHeading,
    size: "xs",
    children: children
  });

  if (withHeading) {
    return /*#__PURE__*/jsxs(Wrapper, _objectSpread2(_objectSpread2({
      variant: variant,
      withHeading: withHeading
    }, otherProps), {}, {
      children: [/*#__PURE__*/jsxs(HeaderWrapper, {
        children: [/*#__PURE__*/jsx(IconWrapper, {
          children: alertIcon
        }), /*#__PURE__*/jsx(HeadingWrapper, {
          size: "sm",
          children: /*#__PURE__*/jsx("strong", {
            children: heading
          })
        })]
      }), alertBody]
    }));
  }

  return /*#__PURE__*/jsxs(Wrapper, _objectSpread2(_objectSpread2({
    variant: variant,
    withHeading: withHeading
  }, otherProps), {}, {
    children: [/*#__PURE__*/jsx(IconWrapper, {
      children: alertIcon
    }), alertBody]
  }));
};

export { Alert, Alert as default };
